import { END_POINTS } from "../constants/url";
import { CommonBody, RoleResponse } from "../types/General";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
  status: number;
  message: string;
  statusCode: number;
}

export const RoleApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getRole: builder.query<
      RoleResponse,
      {
        search?: string;
        length?: number;
        start?: number;
      }
    >({
      query: ({ length, search, start }) => ({
        url: `${END_POINTS.getRole}?start=${start}&length=${length}&search=${search}`,
        method: "GET",
      }),
    }),
    getModule: builder.query<CommonResponseType & { data: any }, {}>({
      query: () => ({
        url: `${END_POINTS.getModules}`,
        method: "GET",
      }),
    }),
    addRole: builder.mutation<
      CommonResponseType & { data: any },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: END_POINTS.addRole,
        method: "POST",
        body,
      }),
    }),
    addModule: builder.mutation<
      CommonResponseType & { data: any },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: END_POINTS.addModules,
        method: "POST",
        body,
      }),
    }),
    getRoleById: builder.query<
      CommonResponseType & { data: any },
      {
        id: number;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.getRoleById}${id}/`,
        method: "GET",
      }),
    }),
    updateRole: builder.mutation<CommonResponseType, { body: any }>({
      query: ({ body }) => ({
        url: `${END_POINTS.addRole}`,
        method: "POST",
        body,
      }),
    }),

    deleteRole: builder.mutation<CommonResponseType, { id: number }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteRole}${id}/`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useLazyGetRoleQuery,
  useAddRoleMutation,
  useLazyGetRoleByIdQuery,
  useUpdateRoleMutation,
  useDeleteRoleMutation,
  useLazyGetModuleQuery,
  useAddModuleMutation,
} = RoleApi;
